import React from "react";

import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { FiscalizationItem } from "../BetDetailsModalFiscalization";
import { DateTime } from "luxon";

export const TransactionTimestamp = observer(
	function TransactionTimestamp(props: {
		firstFinishedTransaction: FiscalizationItem;
		isStart?: boolean;
	}) {
		const { t } = useTranslation("mybets");

		const { firstFinishedTransaction, isStart } = props;

		return (
			<div className="bet__details__row table--bet__fiscalization__row">
				{isStart ? (
					<div className="bet__details__col table--bet__fiscalization__data">
						{t("mybets:ITEM.ADDITIONAL_START_TIME")}:
					</div>
				) : (
					<div className="bet__details__col table--bet__fiscalization__data">
						{t("mybets:ITEM.ADDITIONAL_END_TIME")}:
					</div>
				)}

				<div className="bet__details__col table--bet__fiscalization__data">
					{DateTime.fromISO(
						firstFinishedTransaction.transactionTimestamp
					).toLocaleString(DateTime.DATETIME_SHORT)}
				</div>
			</div>
		);
	}
);
